module.exports = __webpack_public_path__ + "img/earth1.2883b478.png";